import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const getOrganization = organizationId => {
    return RESTClient.getAuthenticatedObservable(`v2/organizations/${organizationId}`);
};

export const getOrganizationOverview = organizationId =>
    RESTClient.getAuthenticatedObservable(`v2/organizations/${organizationId}/overview`).map(institutions =>
        List(institutions),
    );
